import { apiSlice } from '../../api/apiSlice';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface GetSignedUrlsResponse {
    success: boolean;
    uploadId: string;
    signedUrls: string[];
}

export interface MarkCompleteRequest {
    uploadId: string;
    fileName: string;
    chunkCount: number;
}

export interface MarkCompleteResponse {
    success: boolean;
    message?: string;
}

// ---------------------------------------------------------------------------
// Slice — injected into the shared apiSlice so auth headers are handled
// ---------------------------------------------------------------------------

export const voiceRecordingSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        /**
         * Fetches pre-signed GCS URLs for chunked audio upload.
         * Mirrors: GET upload/get-signed-urls?chunkCount=360&fileName={fileName}
         */
        getVoiceRecordingSignedUrls: builder.query({
            query: (arg: { chunkCount: number; fileName: string }) => ({
                url: 'upload/get-signed-urls',
                params: { chunkCount: arg.chunkCount, fileName: arg.fileName },
            }),
        }),

        /**
         * Notifies the backend that all chunks have been uploaded and
         * triggers the GCS compose/combine job.
         * Controller uses [FromForm] — must send FormData, NOT JSON.
         * Mirrors: POST upload/mark-complete
         */
        markVoiceRecordingComplete: builder.mutation({
            query: (body: MarkCompleteRequest) => {
                const formData = new FormData();
                formData.append('uploadId', body.uploadId);
                formData.append('fileName', body.fileName);
                formData.append('chunkCount', String(body.chunkCount));
                return {
                    url: 'upload/mark-complete',
                    method: 'POST',
                    body: formData,
                    // Do NOT set Content-Type — browser must set multipart boundary
                    formData: true,
                };
            },
        }),
    }),
});

export const {
    useLazyGetVoiceRecordingSignedUrlsQuery,
    useMarkVoiceRecordingCompleteMutation,
} = voiceRecordingSlice;
